import { getFormatedDate } from "./date";


// export const buildFootballCSVObject = (reports) => {

//   const headers = [
//     "Season",
//     "Competition/Event",
//     "Teams/Artist",
//     "Home Score",
//     "Away Score",
//     "Kickoff Date",
//     "Kickoff Time",
//     "Pre-match info",
//     "Pre-match communication",
//     "Police category",
//     "Club category",
//     "Club stewards (SIA)",
//     "Club stewards (non-SIA)",
//     "Visiting Club stewards",
//     "Agencies",
//     "Agency Stewards (SIA)",
//     "Agency Stewards (non-SIA)",
//     "Dog agencies",
//     "Traffic Management Plan",
//     "HVM",
//     "Traffic Regulation Order",
//     "Is there a fanzone in operation?",
//     "Are visitors allowed in the fanzone?",
//     "Are any club bars open to visitors?",
//     "Home ticket sales",
//     "Home attendance",
//     "Home entry refusals",
//     "Home ejections",
//     "Home arrests",
//     "Away ticket sales",
//     "Away attendance",
//     "Away entry refusals",
//     "Away ejections",
//     "Away arrests",
//     "Any safeguarding issues?",
//     "Any visitor departure issues?",
//     "Coaches",
//     "Minibuses",
//     "Weather",
//     "Medical Report",
//     "Total number of incidents - spectators",
//     "Incidents due to pre-existing conditions - spectators",
//     "Total number of incidents - staff",
//     "Incidents due to pre-existing conditions - staff",
//     "Other comments",
//   ].join(",");


//   const reportsData = reports
//     .map((report) => {
//       console.log("running")
//       return [
//         report.season || "-",
//         report.competition || "-", // check for event
//         `${report.home_team} - ${report.away_team}` || "-", // check for artist
//         String(report.home_result || 0),
//         String(report.away_result || 0),
//         getFormatedDate(report.event_date) || "-",
//         report.event_time || "-",
//         swapCommaForDot(report.pre_event_info) || "-",
//         swapCommaForDot(report.pre_event_communication) || "-",
//         report.police_security_category || "-",
//         report.club_security_category || "-",
//         swapCommaForDot(report.club_stewards_sia) || "-",
//         swapCommaForDot(report.club_stewards) || "-",
//         swapCommaForDot(report.club_stewards_visiting) || "-",
//         swapCommaForDot(handleArrayToString(report.agency_list || [])) || "-",
//         swapCommaForDot(report.agency_stewards_sia) || "-",
//         swapCommaForDot(report.agency_stewards) || "-",
//         swapCommaForDot(handleArrayToString(report.agency_list_dog)) || "-",
//         swapCommaForDot(report.traffic_management_plan) || "-",
//         answerBoolean(report.is_hmv),
//         answerBoolean(report.traffic_regulation_order),
//         answerBoolean(report.is_fanzone_operation),
//         answerBoolean(report.is_fanzone_visitors_allowed),
//         answerBoolean(report.is_clubs_open_visitors),
//         removeComma(report.home_ticket_sales) || "-",
//         removeComma(report.home_attendance) || "-",
//         removeComma(report.home_entry_refusals) || "-",
//         removeComma(report.home_ejections) || "-",
//         removeComma(report.home_arrests) || "-",
//         removeComma(report.away_ticket_sales) || "-",
//         removeComma(report.away_attendance) || "-",
//         removeComma(report.away_entry_refusals) || "-",
//         removeComma(report.away_ejections) || "-",
//         removeComma(report.away_arrests) || "-",
//         answerBoolean(report.is_safeguarding_issues),
//         answerBoolean(report.is_visitor_departure_issues),
//         report.coaches || "-",
//         report.minibuses || "-",
//         swapCommaForDot(report.weather) || "-",
//         swapCommaForDot(report.medical_report) || "-",
//         swapCommaForDot(report.incidents_total_spectators) || "-",
//         swapCommaForDot(report.incidents_pre_existing_spectators) || "-",
//         swapCommaForDot(report.incidents_total_staff) || "-",
//         swapCommaForDot(report.incidents_pre_existing_staff) || "-",
//         swapCommaForDot(report.other_comments) || "-",
//       ];
//     })
//     .map((z) => z.join(",").concat("\n"))
//     .join("");

//   const csvContent = `data:text/csv;charset=utf-8,${headers}\n${reportsData}`;
//   return csvContent;
// };

// export const exportDataToCSV = (data) => {
//   const timenow = new Date().toISOString();
//   const encodedUri = encodeURI(data);
//   const link = document.createElement("a");
//   link.setAttribute("href", encodedUri);
//   link.setAttribute("download", `${String(timenow)}.csv`);
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };


// export const exportFootballListToCSV = (list) => {


//   const headers = [
//     "Season",
//     "Competition/Event",
//     "Teams/Artist",
//     "Home Score",
//     "Away Score",
//     "Kickoff Date",
//     "Kickoff Time",
//     "Pre-match info",
//     "Pre-match communication",
//     "Police category",
//     "Club category",
//     "Club stewards (SIA)",
//     "Club stewards (non-SIA)",
//     "Visiting Club stewards",
//     "Agencies",
//     "Agency Stewards (SIA)",
//     "Agency Stewards (non-SIA)",
//     "Dog agencies",
//     "Traffic Management Plan",
//     "HVM",
//     "Traffic Regulation Order",
//     "Is there a fanzone in operation?",
//     "Are visitors allowed in the fanzone?",
//     "Are any club bars open to visitors?",
//     "Home ticket sales",
//     "Home attendance",
//     "Home entry refusals",
//     "Home ejections",
//     "Home arrests",
//     "Away ticket sales",
//     "Away attendance",
//     "Away entry refusals",
//     "Away ejections",
//     "Away arrests",
//     "Any safeguarding issues?",
//     "Any visitor departure issues?",
//     "Coaches",
//     "Minibuses",
//     "Weather",
//     "Medical Report",
//     "Total number of incidents - spectators",
//     "Incidents due to pre-existing conditions - spectators",
//     "Total number of incidents - staff",
//     "Incidents due to pre-existing conditions - staff",
//     "Other comments",
//   ].join(",") + "\n";

//   // Build the CSV rows directly without storing all in memory
//   let csvContent = headers;
  
//   // Process each report one at a time
//   list.forEach((report, index) => {
//     if (index % 100 === 0) {
//       console.log(`Processing row ${index} of ${list.length}`);
//     }
    
//     const rowData = [
//       report.season || "-",
//       report.competition || "-",
//       `${report.home_team} - ${report.away_team}` || "-",
//       String(report.home_result || 0),
//       String(report.away_result || 0),
//       getFormatedDate(report.event_date) || "-",
//       report.event_time || "-",
//       swapCommaForDot(report.pre_event_info) || "-",
//       swapCommaForDot(report.pre_event_communication) || "-",
//       report.police_security_category || "-",
//       report.club_security_category || "-",
//       swapCommaForDot(report.club_stewards_sia) || "-",
//       swapCommaForDot(report.club_stewards) || "-",
//       swapCommaForDot(report.club_stewards_visiting) || "-",
//       swapCommaForDot(handleArrayToString(report.agency_list || [])) || "-",
//       swapCommaForDot(report.agency_stewards_sia) || "-",
//       swapCommaForDot(report.agency_stewards) || "-",
//       swapCommaForDot(handleArrayToString(report.agency_list_dog)) || "-",
//       swapCommaForDot(report.traffic_management_plan) || "-",
//       answerBoolean(report.is_hmv),
//       answerBoolean(report.traffic_regulation_order),
//       answerBoolean(report.is_fanzone_operation),
//       answerBoolean(report.is_fanzone_visitors_allowed),
//       answerBoolean(report.is_clubs_open_visitors),
//       removeComma(report.home_ticket_sales) || "-",
//       removeComma(report.home_attendance) || "-",
//       removeComma(report.home_entry_refusals) || "-",
//       removeComma(report.home_ejections) || "-",
//       removeComma(report.home_arrests) || "-",
//       removeComma(report.away_ticket_sales) || "-",
//       removeComma(report.away_attendance) || "-",
//       removeComma(report.away_entry_refusals) || "-",
//       removeComma(report.away_ejections) || "-",
//       removeComma(report.away_arrests) || "-",
//       answerBoolean(report.is_safeguarding_issues),
//       answerBoolean(report.is_visitor_departure_issues),
//       report.coaches || "-",
//       report.minibuses || "-",
//       swapCommaForDot(report.weather) || "-",
//       swapCommaForDot(report.medical_report) || "-",
//       swapCommaForDot(report.incidents_total_spectators) || "-",
//       swapCommaForDot(report.incidents_pre_existing_spectators) || "-",
//       swapCommaForDot(report.incidents_total_staff) || "-",
//       swapCommaForDot(report.incidents_pre_existing_staff) || "-",
//       swapCommaForDot(report.other_comments) || "-",
//     ].join(",") + "\n";
    
//     csvContent += rowData;
//   });
  
//   // Create a Blob with the CSV data
//   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//   const url = URL.createObjectURL(blob);
  
//   // Create download link
//   const timenow = new Date().toISOString();
//   const link = document.createElement("a");
//   link.setAttribute("href", url);
//   link.setAttribute("download", `${String(timenow)}.csv`);
//   document.body.appendChild(link);
//   link.click();
  
//   // Clean up
//   document.body.removeChild(link);
//   URL.revokeObjectURL(url);
// };


export const exportFootballListToCSV = (list) => {
  const headers = [
    "Season",
    "Competition/Event",
    "Teams/Artist",
    "Home Score",
    "Away Score",
    "Kickoff Date",
    "Kickoff Time",
    "Pre-match info",
    "Pre-match communication",
    "Police category",
    "Club category",
    "Club stewards (SIA)",
    "Club stewards (non-SIA)",
    "Visiting Club stewards",
    "Agencies",
    "Agency Stewards (SIA)",
    "Agency Stewards (non-SIA)",
    "Dog agencies",
    "Traffic Management Plan",
    "HVM",
    "Traffic Regulation Order",
    "Is there a fanzone in operation?",
    "Are visitors allowed in the fanzone?",
    "Are any club bars open to visitors?",
    "Home ticket sales",
    "Home attendance",
    "Home entry refusals",
    "Home entry refusals reasons",
    "Home ejections refusals",
    "Home ejections refusals reasons",
    "Home arrests refusals",
    "Home arrests refusals reasons",
    "Away ticket sales",
    "Away attendance",
    "Away entry refusals",
    "Away entry refusals reasons",
    "Away ejections refusals",
    "Away ejections refusals reasons",
    "Away arrests refusals",
    "Away arrests refusals reasons",
    "Any safeguarding issues?",
    "Any visitor departure issues?",
    "Coaches",
    "Minibuses",
    "Weather",
    "Medical Report",
    "Total number of incidents - spectators",
    "Incidents due to pre-existing conditions - spectators",
    "Total number of incidents - staff",
    "Incidents due to pre-existing conditions - staff",
    "Other comments",
  ];
  
  const formatCSVField = (value) => {
    if (value === null || value === undefined || value === "") {
      return "";
    }

    const stringValue = String(value);
    
    if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    
    return stringValue;
  };
  

  const safeGet = (obj, field, defaultValue = "") => {
    return obj?.[field] !== undefined && obj?.[field] !== null ? obj[field] : defaultValue;
  };

  const formatBoolean = (value) => {
    if (value === true) return "Yes";
    if (value === false) return "No";
    return ""; 
  };
  let csvContent = headers.map(h => formatCSVField(h)).join(",") + "\n";
  
  
  list.forEach((report, index) => {
    if (index % 100 === 0) {
      console.log(`Processing row ${index} of ${list.length}`);
    }
    
    
    const rowData = [
      formatCSVField(safeGet(report, 'season')),
      formatCSVField(safeGet(report, 'competition')),
      formatCSVField(`${safeGet(report, 'home_team')} - ${safeGet(report, 'away_team')}`),
      formatCSVField(safeGet(report, 'home_result', '0')),
      formatCSVField(safeGet(report, 'away_result', '0')),
      formatCSVField(report.event_date ? getFormatedDate(report.event_date) : ""),
      formatCSVField(safeGet(report, 'event_time')),
      formatCSVField(safeGet(report, 'pre_event_info')),
      formatCSVField(safeGet(report, 'pre_event_communication')),
      formatCSVField(safeGet(report, 'police_security_category')),
      formatCSVField(safeGet(report, 'club_security_category')),
      formatCSVField(safeGet(report, 'club_stewards_sia')),
      formatCSVField(safeGet(report, 'club_stewards')),
      formatCSVField(safeGet(report, 'club_stewards_visiting')),
      formatCSVField(Array.isArray(report.agency_list) ? report.agency_list.join('; ') : safeGet(report, 'agency_list')),
      formatCSVField(safeGet(report, 'agency_stewards_sia')),
      formatCSVField(safeGet(report, 'agency_stewards')),
      formatCSVField(Array.isArray(report.agency_list_dog) ? report.agency_list_dog.join('; ') : safeGet(report, 'agency_list_dog')),
      formatCSVField(safeGet(report, 'traffic_management_plan')),
      formatBoolean(report.is_hmv),
      formatBoolean(report.traffic_regulation_order),
      formatBoolean(report.is_fanzone_operation),
      formatBoolean(report.is_fanzone_visitors_allowed),
      formatBoolean(report.is_clubs_open_visitors),
      formatCSVField(safeGet(report, 'home_ticket_sales')),
      formatCSVField(safeGet(report, 'home_attendance')),
      formatCSVField(safeGet(report, 'home_entry_refusals')),
      formatCSVField(safeGet(report, 'home_entry_refusals_reasons')),
      formatCSVField(safeGet(report, 'home_ejections')),
      formatCSVField(safeGet(report, 'home_ejections_reasons')),
      formatCSVField(safeGet(report, 'home_arrests')),
      formatCSVField(safeGet(report, 'home_arrests_reasons')),
      formatCSVField(safeGet(report, 'away_ticket_sales')),
      formatCSVField(safeGet(report, 'away_attendance')),
      formatCSVField(safeGet(report, 'away_entry_refusals')),
      formatCSVField(safeGet(report, 'away_entry_refusals_reasons')),
      formatCSVField(safeGet(report, 'away_ejections')),
      formatCSVField(safeGet(report, 'away_ejections_reasons')),
      formatCSVField(safeGet(report, 'away_arrests')),
      formatCSVField(safeGet(report, 'away_arrests_reasons')),
      formatBoolean(report.is_safeguarding_issues),
      formatBoolean(report.is_visitor_departure_issues),
      formatCSVField(safeGet(report, 'coaches')),
      formatCSVField(safeGet(report, 'minibuses')),
      formatCSVField(safeGet(report, 'weather')),
      formatCSVField(safeGet(report, 'medical_report')),
      formatCSVField(safeGet(report, 'incidents_total_spectators')),
      formatCSVField(safeGet(report, 'incidents_pre_existing_spectators')),
      formatCSVField(safeGet(report, 'incidents_total_staff')),
      formatCSVField(safeGet(report, 'incidents_pre_existing_staff')),
      formatCSVField(safeGet(report, 'other_comments')),
    ].join(",");
    
    csvContent += rowData + "\n";
  });
  
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  
  const timenow = new Date().toISOString();
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", `football_data_${String(timenow)}.csv`);
  document.body.appendChild(link);
  link.click();
  
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  
};

